import UtilOrder from '@pages/OrganizedSales/CreateOrders/utilOrder';
import { ThunkDispatch } from '@reduxjs/toolkit';
import {
  addHistoryNoti,
  addNotification,
  changeQActionOrder,
  getDetailOfOrder,
  pushNotifications,
  removeNotification,
  updateOrderSelected
} from '@slice/orderManager.slice';
import { RootState } from 'app/store';
import React, { useEffect, useRef } from 'react';
import toast, { useToaster } from 'react-hot-toast/headless';
import { useTranslation } from 'react-i18next';
import { batch, useDispatch, useSelector } from 'react-redux';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useNavigate } from 'react-router-dom';
import { getMessagingToken, onMessageListener } from '../../firebase';

import { useExtendDeviceToken } from 'apis/queries';
import { INTERVAL_DTOKEN } from 'global/Global';
import AuthServiceApi from 'apis/api/Auth';
import { updateDeviceTokenMessage } from '@slice/user.slice';
import { message } from 'antd';
import { pushNotifyTicket } from '@slice/select.slice';
import { INotification } from './NotifyFirebase/WapperNotification';

const Notifications = () => {
  const { t } = useTranslation();
  const { toasts, handlers } = useToaster();
  const { startPause, endPause, calculateOffset, updateHeight } = handlers;

  const hover = useRef<any>(null);

  const handleDismiss = (id: any) => {
    toast.remove(id);
  };

  const handleCloseAll = () => {
    toast.dismiss();
    toast.remove();
  };

  const onMouseEnter = () => {
    hover.current = true;
    startPause();
  };

  const onMouseLeave = () => {
    hover.current = false;
    endPause();
  };

  return (
    <div
      style={{
        zIndex: 10000,
        position: 'fixed',
        top: 75,
        right: 0,
        display: toasts.length > 0 ? 'unset' : 'none'
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {hover.current && (
        <div
          style={{ zIndex: 10001 }}
          className="bg-orange-100 absolute px-2 -top-5 right-[10px] hover:underline flex justify-between select-none"
          onClick={() => {
            handleCloseAll();
          }}
        >
          {/* <div className="whitespace-nowrap">{t('Notification.Title')}</div> chưa cần dùng để tạm ẩn đây */}
          {`${'❌ '}`}
          <span className="whitespace-nowrap text-red-900  hover:text-red-600 cursor-pointer">
            {t('Notification.CloseAll')} {`${' '}`} {`(${toasts.length})`}
          </span>
        </div>
      )}

      <PerfectScrollbar
        className="absolute notify-order-wapper"
        style={{
          width: '250px',
          minHeight: '0',
          height:
            toasts.length > 3
              ? '56vh'
              : toasts.length > 2
              ? '46vh'
              : toasts.length > 1
              ? '31vh'
              : toasts.length > 0
              ? '16vh'
              : 0,
          top: '0%',
          right: '0%',
          paddingBottom: '10px'
        }}
      >
        {toasts.map(toast => {
          const offset = calculateOffset(toast, {
            reverseOrder: false,
            gutter: 8
          });

          const ref = el => {
            if (el && typeof toast.height !== 'number') {
              const height = el.getBoundingClientRect().height;
              updateHeight(toast.id, height);
            }
          };

          const child: any = toast.message;

          // tạo style custom màu theo thêm luôn!!
          return (
            <div
              key={toast.id}
              ref={ref}
              style={{
                zIndex: 1000,
                position: 'absolute',
                width: '240px',
                minWidth: '240px',
                maxWidth: '240px',
                background: 'papayawhip',
                transition: 'all 0.5s ease-out',
                opacity: toast.visible ? 1 : 0,
                transform: `translateY(${offset}px)`,
                padding: '10px',
                borderBottomRightRadius: '5px',
                borderTopLeftRadius: '5px',
                borderBottomLeftRadius: '5px'
              }}
            >
              <button
                className="absolute -bottom-0.5 right-1 text-red-600 underline hover:text-red-500 cursor-pointer"
                onClick={() => handleDismiss(toast.id)}
              >
                {t('Notification.Dismiss')}
              </button>
              {child}
            </div>
          );
        })}
      </PerfectScrollbar>
    </div>
  );
};

export interface IDivToast {
  key?: any;
  handleDetail: (maDonHang?: any, orderTypeId?: number, isTransactionRoute?: boolean) => any;
  handleMenu: (maDonHang?: any, orderTypeId?: number, isTransactionRoute?: boolean) => any;
  handleQActions: (maDonHang?: any, orderTypeId?: number) => any;
  notification?: INotification;
}

const normalizeTitle = (value?: string) => {
  return (value ?? '').trim().toLowerCase().normalize('NFC');
};

const getTransactionSubTitle = ({ title, isWarehouse }: { title?: string; isWarehouse: boolean }) => {
  const transactionTitle = normalizeTitle(title);
  console.log({ transactionTitle, title });

  if (transactionTitle.includes('cấp')) {
    return isWarehouse ? 'Xác nhận/từ chối cấp phát.' : 'Có lệnh cấp phát.';
  }

  if (transactionTitle.includes('trao đổi')) {
    return isWarehouse ? 'Đã xác nhận/từ chối trao đổi.' : 'Có lệnh trao đổi.';
  }

  if (transactionTitle.includes('trả hàng')) {
    return isWarehouse ? 'Có lệnh trả hàng.' : 'Đã xác nhận/từ chối trả hàng.';
  }

  if (transactionTitle.includes('cập nhật')) {
    return isWarehouse ? 'Có yêu cầu cập nhật.' : 'Đã xác nhận/từ chối cập nhật.';
  }

  if (transactionTitle.includes('thu hồi')) {
    return isWarehouse ? 'Có lệnh thu hồi.' : 'Đã xác nhận/từ chối thu hồi.';
  }

  return '';
};

// sau sẽ dùng cho thông báo đã nhận !!
export function DivToast(props: IDivToast) {
  const { t } = useTranslation();
  const uLogin = useSelector((state: RootState) => state.user.account);

  const isTicket = props.notification.idPhieu; // là phiếu hỗ trợ chứ k phải đơn hàng
  const navigate = useNavigate();
  // Bấm mã phiếu -> sang Quản lý phiếu kèm ?ticketId=, trang đó tự mở phiếu (TicketManager đọc query).
  // TicketIds có thể là "12" hoặc "12,13" -> mở phiếu đầu tiên
  const openTicket = () => {
    const id = String(props.notification?.idPhieu ?? '')
      .split(',')[0]
      .trim();
    if (id) navigate(`/quan-ly-phieu?ticketId=${id}`);
  };
  const body = props.notification?.body;
  const staffBehavior = body?.staffBehavior ?? '';

  const isTransaction = staffBehavior.includes('Transaction');
  const isWarehouse = isTransaction && uLogin?.role === 'WareHouse';

  const transactionSubTitle = isTransaction
    ? getTransactionSubTitle({
        title: props.notification?.title,
        isWarehouse
      })
    : '';

  const min = 0;
  const listIcon: any = [
    <span key="1">🌻</span>,
    <span key="2">🔥</span>,
    <span key="3">👏</span>,
    <span key="4">🌤️</span>,
    <span key="5">🙃</span>,
    <span key="6">💥</span>,
    <span key="7">✨</span>,
    <span key="8">💯</span>,
    <span key="9">⭐</span>,
    <span key="10">🎉</span>,
    <span key="11">🍻</span>,
    <span key="12">🎈</span>,
    <span key="13">💛</span>,
    <span key="14">🖖</span>,
    <span key="15">👍</span>
  ];

  const formatStatus = isTicket
    ? UtilOrder.convertStatusTicket(props.notification?.body?.State)
    : UtilOrder.convertStatusTextToStatusClient(
        props.notification?.body?.currentOrderStatus,
        props.notification?.body?.staffBehavior == 'OperatorSeen' || false
      );

  const notificationLabel =
    staffBehavior.includes('Transaction') || isTicket ? props.notification?.title : t('Notification.Order');

  return (
    <div key={props.key} className="cursor-normal w-full">
      <div className="font-semibold !text-sm whitespace-nowrap">
        {listIcon[Math.floor(Math.random() * (listIcon.length - min)) + min]}
        {notificationLabel}:{' '}
        <span
          className="text-red-600 hover:underline hover:text-red-500 cursor-pointer"
          onClick={() => {
            if (isTicket) openTicket();
            else
              props.handleDetail(
                props.notification?.maDonHang,
                Number(props.notification?.body.orderTypeId),
                !!transactionSubTitle
              );
          }}
        >
          {isTicket ? props.notification?.body?.TicketCodes : props.notification?.body?.maDonHang}
        </span>
      </div>
      <div className="select-none">
        <span
          style={{ backgroundColor: `${formatStatus?.color}` }}
          className="relative text-sm whitespace-nowrap text-white w-fit h-fit border rounded-sm px-1 "
        >
          {formatStatus?.seen == false && (
            <div className="absolute w-[10px] h-[10px] bg-[#FFD23F] -top-[4px] -right-[4px]  rounded-full"></div>
          )}
          {t(formatStatus?.text)}
        </span>
        {'  '}
        {!transactionSubTitle && !isTicket && (
          <>
            {'  '}
            <span
              className="text-blue-500 underline hover:text-blue-400 cursor-pointer"
              onClick={() => {
                props.handleQActions(props.notification?.maDonHang, +props.notification?.body.orderTypeId);
              }}
            >
              {t('Notification.QAction')}
            </span>
          </>
        )}
        {'  '}
        {!isTicket && (
          <span
            className="text-blue-500 underline hover:text-blue-400 cursor-pointer"
            onClick={() => {
              props.handleMenu(
                props.notification?.maDonHang,
                +props.notification?.body.orderTypeId,
                !!transactionSubTitle
              );
            }}
          >
            {t('Notification.Menu')}
          </span>
        )}
      </div>
      <div className="select-none">
        <span className="font-semibold"> {props.notification?.body?.staffSend}</span>
        {' – '}
        <span className="">
          {transactionSubTitle
            ? transactionSubTitle
            : t('OrganizedSales.OrderManager.ModifyOrder.TimelineStatus.' + props.notification?.body?.staffBehavior)}
        </span>
      </div>
    </div>
  );
}

export default function WapperNotification() {
  const { t } = useTranslation();
  const notification = useSelector((state: RootState) => state.orderManager.notification);
  const isACNotify = useSelector((state: RootState) => state.orderManager.isACNotify);
  const deviceTokenMessage = useSelector((state: RootState) => state.user.deviceTokenMessage);
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  const history = useNavigate();

  // cần xử lý như dạng này nếu đơn này chưa có trong list đơn bên menu quản lý đơn //

  const handleDetail = (maDonHang: string, orderTypeId?: number, isTransactionRoute?: boolean) => {
    console.log('maDonHang', maDonHang);

    if (isTransactionRoute) {
      handleMenu(maDonHang, orderTypeId, true);
      toast.remove(maDonHang);
      return;
    }

    if (window.location.pathname !== '/quan-ly-don-hang') {
      handleMenu(maDonHang, orderTypeId);
      toast.remove(maDonHang);
    } else {
      dispatch(getDetailOfOrder({ maDonHang: maDonHang, typeOrder: +orderTypeId, forceOpen: true }));

      const notifyC = { maDonHang: maDonHang, clearAll: false };
      dispatch(removeNotification(notifyC));
      return;
    }
  };

  const handleMenu = (maDonHang: string, orderTypeId?: number, isTransactionRoute?: boolean) => {
    if (isTransactionRoute) {
      history('/kho-ky-thuat?tab=2');
      return;
    }

    history('/quan-ly-don-hang' + `?maDonHang=${maDonHang}`);
  };
  const handleQActions = (maDonHang: string, orderTypeId?: number) => {
    console.log('maDonHang', maDonHang);
    dispatch(updateOrderSelected(maDonHang)); //
    dispatch(changeQActionOrder(true));
  };

  useEffect(() => {
    console.log('setUp nhận FCM in cpn');
    // change khai báo từ service của broswer chờ nhận msg từ FCM khi chạy dưới nền
    const channel = new BroadcastChannel('notifications');
    channel.addEventListener('message', payload => {
      console.log('payload bg fcm', payload);
      const dataOrder = payload.data?.data;
      const msgOrder: any = {
        title: (payload?.data.notification && payload.data.notification.title) || '',
        body: (dataOrder && { ...dataOrder }) || {}
      };

      msgOrder['maDonHang'] = msgOrder.body.maDonHang;
      console.log('Receive background msg in cpn: ', msgOrder);
      dispatch(pushNotifications(msgOrder));
      dispatch(pushNotifyTicket(msgOrder));
    });

    return () => {
      if (refIntervalDeviceToken.current) {
        clearInterval(refIntervalDeviceToken.current);
        refIntervalDeviceToken.current = null;
      }
    };
  }, []);

  const mutationOpts = {
    onSuccess: result => {
      console.log('result extend device token ...', result);
    },
    onError: err => {
      console.log('err extend device token ...', err);
    }
  };
  // console.log('notify', Notification.permission);

  const [isLoading, handleAdd]: any = useExtendDeviceToken(mutationOpts);
  const handleOk = (values: Partial<any>) => {
    handleAdd(values);
  };

  const refIntervalDeviceToken = useRef<any>(null);

  const setUpTokenMessage = async (retryCount = 0) => {
    const tokenDevice = await getMessagingToken();

    if (!tokenDevice || tokenDevice === '' || tokenDevice === null) {
      if (retryCount < 3) {
        setTimeout(() => setUpTokenMessage(retryCount + 1), 500); // Delay 0.5s
      } else {
        console.warn('Quá số lần thử lấy token');
      }
      return;
    }

    const bodyAPI = {
      deviceToken: tokenDevice,
      platform: 'web',
      version: '',
      deviceId: ''
    };
    console.log('setUpTokenMessage');

    try {
      const res = await AuthServiceApi.UpdateDeviceToken(bodyAPI);
      if (!res.data.error) {
        dispatch(updateDeviceTokenMessage(bodyAPI));
        message.success(t('Notification.SetUpFCMOk'));
      }
    } catch (error) {
      console.log('send tokenDevice err', tokenDevice);
    }
  };

  useEffect(() => {
    const isTokenMissing = !deviceTokenMessage;
    console.log('isTokenMissing', isTokenMissing);

    const checkAndSetupToken = async () => {
      const permission = Notification.permission;

      if (permission === 'granted') {
        if (isTokenMissing) {
          await setUpTokenMessage();
        }
      }
      // else if (permission === 'default') {
      //   const result = await Notification.requestPermission();
      //   if (result === 'granted' && isTokenMissing) {
      //     await setUpTokenMessage();
      //   } else {
      //     dispatch(updateDeviceTokenMessage(null));
      //   }
      // }
      else {
        dispatch(updateDeviceTokenMessage(null));
        console.warn('Thông báo đã bị chặn bởi trình duyệt.');
      }
    };

    checkAndSetupToken();
  }, []);

  useEffect(() => {
    const isTokenValid = deviceTokenMessage;
    console.log('isTokenValid', isTokenValid);

    if (!isTokenValid) {
      console.log('isToken', isTokenValid);

      // setUpTokenMessage();
      return;
    }

    if (refIntervalDeviceToken.current) {
      clearInterval(refIntervalDeviceToken.current);
      refIntervalDeviceToken.current = null;
    }

    handleOk(deviceTokenMessage);

    refIntervalDeviceToken.current = setInterval(() => {
      handleOk(deviceTokenMessage);
    }, INTERVAL_DTOKEN);

    return () => {
      if (refIntervalDeviceToken.current) {
        clearInterval(refIntervalDeviceToken.current);
        refIntervalDeviceToken.current = null;
      }
    };
  }, [deviceTokenMessage]);

  // Notification.permission
  useEffect(() => {
    console.log('notification', notification);

    // khi đang ở tab này
    onMessageListener()
      .then((payload: any) => {
        const msgOrder: any = {
          title: (payload?.notification && payload.notification.title) || '',
          body: (payload?.data && { ...payload.data }) || {}
        };
        msgOrder['maDonHang'] = msgOrder.body.maDonHang;
        console.log('FCM', payload);
        dispatch(pushNotifications(msgOrder));

        // sau này có idPhieu để biết này là ticket... giờ để tạm dùng chung
        dispatch(pushNotifyTicket(msgOrder));

        // đẩy vào trung tâm thông báo của máy đang xem giống như thông báo nền
        try {
          if ('serviceWorker' in navigator) {
            navigator.serviceWorker
              .register('./firebase-messaging-sw.js', { scope: './' })
              .then(function (registration) {
                console.log('Service Worker Registered');
                setTimeout(() => {
                  registration.showNotification(msgOrder.title, { body: 'Đơn hàng cập nhật, Xem ngay****' });
                  registration.update();
                }, 100);
              })
              .catch(function (err) {
                console.log('Service Worker Failed to Register', err);
              });
          }
        } catch (error) {
          console.log('error bg win', error);
        }

        return null;
      })
      .catch(err => console.log('failed FCM: ', err));
    if (notification) {
      batch(() => {
        dispatch(addNotification(notification)); // thêm vào thông báo save
        dispatch(addHistoryNoti(notification)); // thêm vào lịch sử thông báo save
      });

      // thêm vào thông báo 10s
      toast(
        <DivToast
          notification={notification}
          handleDetail={handleDetail}
          handleMenu={handleMenu}
          handleQActions={handleQActions}
        />,
        {
          id: notification?.maDonHang,
          duration: isACNotify ? 10000 : 60000 * 60
        }
      );

      // thêm vào ds đơn hàng nếu đang ở menu ds đơn hàng
      window.location.pathname === '/quan-ly-don-hang' &&
        dispatch(getDetailOfOrder({ maDonHang: notification?.maDonHang, typeOrder: +notification?.body.orderTypeId })); // gọi lên lấy data mới luôn !!
      // bật xong thì xoá đi
      dispatch(pushNotifications(null));
    }
  }, [notification?.maDonHang]);
  // notification
  // phần cấu hình thông báo firebase cần tự cấu hình lại thông báo

  // phần cấu hình nhận đc thông báo ticket
  // xử lý xoá  dispatch(pushNotifyTicket(null)) là đc tạm thời chỉ vậy à sẽ làm thêm việc khác chắc phải tách hook riêng .. phần order giữ nguyên ở đây...

  // nhưng phần token firebase thì chung đc ko ta..

  return <Notifications />;
}
